import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import ReleaseFlag from './enumReleaseFlags';

export interface ReleaseFlagsResult {
  success: boolean;
  // Key is an index number, value is the release flag
  data: Record<number, ReleaseFlag>;
}

export interface ReleaseFlagsError {}

const usePublicReleaseFlags = (canLoad = true) => {
  const { data, error, isLoading, mutate, isValidating } = useSWR<
    ReleaseFlagsResult,
    ReleaseFlagsError
  >(canLoad ? `${process.env.VITE_API_ROOT}/releaseflags/public` : null, getFetcher);

  const publicReleaseFlags = useMemo(() => new Set(Object.values(data?.data ?? {})), [data]);

  return {
    publicReleaseFlags,
    error,
    isLoading,
    mutate,
    isValidating,
  };
};

export default usePublicReleaseFlags;
